import React from 'react';

export const praTitle = 'Paperwork Reduction Act Statement';
export const pra = [
    {
        header: "Paperwork Reduction Act Statement",
        content:
        "<p>The public reporting burden to complete this information collection is estimated at: <br/>" +
        "<ul><li>45 minutes per response for a candidate; or,</li>" +
        "<li>5 minutes per response for a flight training provider,</li></ul>" +
        "including the time for reviewing instructions searching existing data sources, gathering and " +
        "maintaining the data needed, and completing and reviewing the collected information. TSA may " + 
        "not conduct or sponsor, and a person is not required to respond to a collection of information " + 
        "unless it displays a currently valid OMB control number and expiration date. The OMB control " + 
        "number assigned to this collection is 1652-0021, EXP. 07/31/2022.<br/><br/>" +
        "Send comments regarding this burden estimate or any other aspect of this collection of information, " + 
        "including suggestions for reducing this burden to:<br/><br/>" +
        "<div style='margin-left: 35px;'>Transportation Security Administration - TSA-11<br/>" +
        "Attention: PRA 1652-0021 - Flight Training Security<br/>" + 
        "6595 Springfield Center Drive, Springfield, VA 20598-6011</div></p>"
    }
];

export const pasTitle = "Privacy Act Statement";
export const pas = [
    {
        header: 'AUTHORITY',
        content:
        "6 U.S.C. § 1140, 46 U.S.C. § 70105; 49 U.S.C. §§ 106, 114, 5103a, 40103(b)(3), 40113, " +
        "44903, 44935-44936, 44939, and 46105; the Implementing Recommendations of the 9/11 Commission Act " +
        "of 2007, § 1520 (121 Stat. 444, Public Law 110-52, August 3, 2007); and Executive Order 9397, as amended."
    },

    {
        header: 'Purpose',
        content:
        "The Department of Homeland Security (DHS) will use the biographic information to conduct a " +
        "security threat assessment. Your fingerprints and associated information will be provided to the " +
        "Federal Bureau of Investigation (FBI) for the purpose of comparing your fingerprints to other " +
        "fingerprints in the FBI's Next Generation Identification (NGI) system or its successor systems " +
        "including civil, criminal, and latent fingerprint repositories. The FBI may retain your fingerprints " +
        "and associated information in NGI after the completion of this application and, while retained, your " +
        "fingerprints may continue to be compared against other fingerprints submitted to or retained by NGI. " +
        "DHS will also transmit your fingerprints for enrollment into US-VISIT Automated Biometrics Identification " +
        "System (IDENT). If you provide your Social Security Number (SSN), DHS may provide your name and SSN " +
        "to the Social Security Administration (SSA) to compare that information against SSA records to ensure " +
        "the validity of the information."
    },

    {
        header: 'Routine Uses',
        content:
        "In addition to those disclosures generally permitted under 5 U.S.C. 522a(b) of the Privacy " +
        "Act, all or a portion of the records or information contained in this system may be disclosed outside " +
        "DHS as a routine use pursuant to 5 U.S.C. 522a(b)(3) including with third parties during the course " +
        "of a security threat assessment, employment investigation, or adjudication of a waiver or appeal " +
        "request to the extent necessary to obtain information pertinent to the assessment, investigation, or " +
        "adjudication of your application or in accordance with the routine uses identified in the TSA system " +
        "of records notice (SORN) DHS/TSA 002, Transportation Security Threat Assessment System. For as long as " +
        "your fingerprints and associated information are retained in NGI, your information may be disclosed " +
        "pursuant to your consent or without your consent as permitted by the Privacy Act of 1974 and all " +
        "applicable Routine Uses as may be published at any time in the Federal Register, including the Routine " +
        "Uses for the NGI system and the FBI's Blanket Routine Uses."
    }
];
